import {Component} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthService} from '@modules/authentication/services/auth.service';
import {Router} from '@angular/router';
import {ngLock, ngLockElementByQuerySelector, ngUnlock} from '@core/decorators/ng-lock.decorator';
import {FORM_VALIDATORS, VALIDATORS} from '@modules/authentication/components/login/login.validator';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {FcmService} from '@core/service/fcm.service';

@Component({
  templateUrl: './login.component.html',
})

export class LoginComponent {
  readonly VALIDATORS = VALIDATORS;
  readonly FORM_VALIDATORS = FORM_VALIDATORS;
  loginForm: UntypedFormGroup;
  isSubmitted = false;
  showPassword: boolean = false;

  get f() {
    return this.loginForm.controls;
  }

  @ngLock({
    lockElementFunction: ngLockElementByQuerySelector('#loginBtn'),
  })
  submitForm(): void {
    for (const i in this.loginForm.controls) {
      this.loginForm.controls[ i ].markAsDirty();
      this.loginForm.controls[ i ].updateValueAndValidity();
    }
    this.isSubmitted = true;
    if (this.loginForm.valid) {
      this.authService.login(this.loginForm.value).subscribe(res => {
          if (res) {
            switch (res.messageCode) {
              case MESSAGE_CODE.SUCCESS:
                this.authService.saveStorage(res);
                this.router.navigate(['/dashboard/home']);
                this.fcmService.getFcmToken().subscribe(token => {
                  console.log('FCM Token:', token);
                  if (token) this.authService.registerFcmToken(token).subscribe();
                });
                break;
              case MESSAGE_CODE.WRONG_PASSWORD :
                this.f.password.setErrors({notMatch: true});
                break;
              case MESSAGE_CODE.USER_NOT_EXIST :
                this.f.username.setErrors({notExist: true});
                break;
              case MESSAGE_CODE.USER_VERIFY:
                this.f.username.setErrors({needVerify: true});
                break;
              case MESSAGE_CODE.USER_LOCKED:
                this.f.username.setErrors({locked: true});
                break;
              default:
                this.loginForm.setErrors({systemError: true});
                break;
            }
          } else {
            this.loginForm.setErrors({systemError: true});
          }
        }, error => {
          this.loginForm.setErrors({systemError: true});
          ngUnlock(this.submitForm)
        }, () => ngUnlock(this.submitForm)
      );
    } else {
      ngUnlock(this.submitForm);
    }
  }

  constructor(private fb: UntypedFormBuilder,
              private authService: AuthService,
              private router: Router,
              private fcmService: FcmService,
  ) {
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]]
    });
  }
}
